import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { KIND_LABELS } from '@leits/shared/client';
const CHOICE_KINDS = ['single_choice', 'multi_choice', 'matching', 'matching_headings'];
/**
 * 渲染成「单选组」的题型。
 *
 * 判断题（T/F/NG、Y/N/NG）也是单选，必须在这里列出来：
 * 它们的选项是固定的三个，`optionsFor()` 会把 FIXED_OPTIONS 填进来。
 * 早期版本漏了这两种，导致判断题被渲染成一个空白文本框——用户得自己手打 TRUE/FALSE/NOT GIVEN。
 */
const RADIO_KINDS = [...CHOICE_KINDS, 'tfng', 'ynng'];
function optionsFor(question, group) {
    if (question.kind === 'tfng' || question.kind === 'ynng') {
        return (question.options ??
            (question.kind === 'tfng'
                ? [
                    { key: 'TRUE', text: 'TRUE' },
                    { key: 'FALSE', text: 'FALSE' },
                    { key: 'NOT GIVEN', text: 'NOT GIVEN' },
                ]
                : [
                    { key: 'YES', text: 'YES' },
                    { key: 'NO', text: 'NO' },
                    { key: 'NOT GIVEN', text: 'NOT GIVEN' },
                ]));
    }
    if (question.kind === 'matching' || question.kind === 'matching_headings') {
        return group.options ?? question.options ?? [];
    }
    return question.options ?? [];
}
/** 按题型渲染作答控件。内容里没有控件 markup，控件全部由这里生成（PLAN 4.1）。 */
export function QuestionControl({ question, group, value, autoFocus, onChange }) {
    const label = `第 ${question.displayNumber} 题（${KIND_LABELS[question.kind]}）`;
    if (RADIO_KINDS.includes(question.kind) && question.kind !== 'multi_choice') {
        const options = optionsFor(question, group);
        return (_jsx("div", { className: "question__controls", role: "radiogroup", "aria-label": label, children: options.map((option, index) => {
                const selected = value === option.key;
                return (_jsxs("label", { className: selected ? 'option is-selected' : 'option', children: [_jsx("input", { type: "radio", name: question.id, value: option.key, checked: selected, autoFocus: autoFocus && index === 0, onChange: () => onChange(question.id, option.key) }), _jsx("span", { className: "option__key", children: option.key }), _jsx("span", { children: option.text })] }, option.key));
            }) }));
    }
    if (question.kind === 'multi_choice') {
        const options = optionsFor(question, group);
        const picked = value ? value.split(',').filter(Boolean) : [];
        return (_jsx("div", { className: "question__controls", role: "group", "aria-label": label, children: options.map((option) => {
                const selected = picked.includes(option.key);
                return (_jsxs("label", { className: selected ? 'option is-selected' : 'option', children: [_jsx("input", { type: "checkbox", checked: selected, onChange: () => {
                                const next = selected
                                    ? picked.filter((key) => key !== option.key)
                                    : [...picked, option.key];
                                onChange(question.id, next.sort().join(','));
                            } }), _jsx("span", { className: "option__key", children: option.key }), _jsx("span", { children: option.text })] }, option.key));
            }) }));
    }
    return (_jsxs("div", { className: "question__controls", children: [_jsx("label", { className: "sr-only", htmlFor: `input-${question.id}`, children: label }), _jsx("input", { id: `input-${question.id}`, className: "blank-input", value: value, autoFocus: autoFocus, autoComplete: "off", spellCheck: false, placeholder: "\u5728\u6B64\u586B\u5199\u7B54\u6848", onChange: (event) => onChange(question.id, event.target.value) })] }));
}
/** 把题干里的空位标记（<strong>5</strong> ______）换成输入框位置提示。 */
export function normalizePromptHtml(html) {
    return html.replace(/_{2,}/g, '<span class="blank-slot">____</span>');
}
//# sourceMappingURL=QuestionControl.js.map